export default __webpack_public_path__ + "static/media/news-details-banner.5519d41e.png";